import styled from "@emotion/styled";
import { Button } from "@kaltura/ds-react-components";

export const HeaderContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    height: 56,
    borderBottom: `1px solid ${theme.kaltura.palette.tone4}`,
    padding: theme.spacing(1.5, 2),
    gap: theme.spacing(2),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
        gap: theme.spacing(1),
    },
}));

export const StyledBackButton = styled(Button)(({ theme }) => ({
    color: theme.kaltura.palette.tone1,
    flexShrink: 0,
}));

export const CenterSection = styled("div")(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) auto minmax(0, 1fr)",
    gridColumnGap: theme.spacing(3),
    alignItems: "center",
    flex: 1,
}));

export const TitleContainer = styled("div")({
    gridColumn: "1",
    maxWidth: "100%",
});

export const TabsContainer = styled("div")(({ theme }) => ({
    gridColumn: "2",
    justifySelf: "center",
    display: "flex",
    alignItems: "center",
}));

export const SaveButtonContainer = styled("div")({
    flexShrink: 0,
});
